(() => {
  const token = 'c3c8c2461cccaf7ae9274444574732d7cd1ceb141748e529fccbfd1f784deaba';
  const DomainIB4B = 'https://api.ifing-beauty.com';
  
  fetchFourbData = async (url) => {
    return $.ajax({
      url: url,
      headers: {
        Token: token,
      },
      type: 'GET',
      dataType: 'json',
      success: (data) => {
        return data;
      },
      error: (error) => {
        document.cookie = 'ib_user_regist_salon_id=; Max-Age=0; path=/; Secure; SameSite=None';
        alert('データの取得に失敗しました')
      }
    });
  }

  fetchSalonList = async (url, freeWord, salonType, areaId) => {
    return  $.ajax({
      url: url,
      headers: {
        Token: token,
      },
      type: 'POST',
      data : {
        freeWord: freeWord,
        salonType: salonType,
        areaId: areaId
      },
      dataType: 'json',
      success: (data) => {
        return data;
      },
      error: (error) => {
        //alert('サロン情報の取得に失敗しました')
      }
    });
  };

  // グローバルオブジェクトに登録
  window.IB4BClient = {
    fetchFourbData,
    fetchSalonList,
    DomainIB4B,
  };

})();